export default __webpack_public_path__ + "static/Plots0000-d3d5147fadbb2512a359e957474a28f6.jpg";